<template>
  <div>
    <div class="large-padding-bottom-l large-padding-top-xl small-padding-top-m small-padding-bottom-m">
      <div class="grid-x align-center-middle grid-margin-x grid-margin-y">
        <div class="cell small-12 medium-12 large-8 xlarge-8">
          <div class="grid-x align-center-middle">
            <div class="cell small-2 medium-1 large-3 xlarge-2 medium-padding-0 large-padding-bottom-xxs padding-bottom-s small-padding-bottom-xs">
              <div>
                <AtomicUiSkeleton
                  :height="checkMew ? '60px' : '130px'"
                  :width="checkMew ? '60px' : '130px'"
                  class="event-type-image"
                  style="border-radius: 50%"
                  :class="{ skeleton: checkMew }"
                />
              </div>
            </div>
            <div class="cell small-12 medium-12 large-9 xlarge-10 registry-info">
              <div class="medium-align-middle eyebrow large-text-left text-center occasion-type" style="margin: auto">
                <AtomicUiSkeleton height="18px" width="130px" class="skeleton" />
              </div>
              <div class="large-text-left text-center margin-top-xxs">
                <AtomicUiSkeleton :height="checkMew ? '26px' : '30px'" :width="checkMew ? '80%' : '50%'" class="skeleton" />
              </div>
              <div class="registry-event-details grid-x">
                <div class="grid-x cell" :class="{ 'align-center': checkMew }">
                  <!-- eslint-disable -->
                  <div
                    class="xlarge-padding-right-xs medium-padding-right-xxs medium small-padding-right-xxs medium-margin-top-xs margin-top-xs small-margin-top-xs"
                  >
                    <AtomicUiSkeleton height="20px" width="86px" />
                  </div>
                  <div
                    class="xlarge-padding-right-xs xlarge-padding-left-xs padding-left-xxs padding-right-xxs grid-x medium medium-margin-top-xs margin-top-xs small-margin-top-xs"
                  >
                    <AtomicUiSkeleton height="20px" width="136px" />
                  </div>
                  <div
                    v-if="isRegistrant"
                    class="xlarge-padding-right-xs xlarge-padding-left-xs padding-left-xxs padding-right-xxs align-center grid-x medium-margin-top-xs margin-top-xs small-margin-top-xs"
                  >
                    <div class="align-center-middle grid-x">
                      <div class="medium-margin-right-xxs" style="width: 15px; height: 15px">
                        <AtomicUiSkeleton height="14px" width="14px" />
                      </div>
                      <div class="show-for-large">
                        <AtomicUiSkeleton height="20px" width="121px" />
                      </div>
                    </div>
                  </div>
                  <br />
                  <div
                    v-if="isRegistrant"
                    class="xlarge-padding-right-xs xlarge-padding-left-xs padding-left-xxs padding-right-xxs align-center grid-x medium-margin-top-xs margin-top-xs small-margin-top-xs"
                  >
                    <div class="align-center-middle grid-x">
                      <div class="medium-margin-right-xxs" style="width: 15px; height: 15px">
                        <AtomicUiSkeleton height="14px" width="14px" />
                      </div>
                      <div class="show-for-large">
                        <AtomicUiSkeleton height="20px" width="52px" />
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="isRegistrant"
                    class="xlarge-padding-left-xs small-padding-left-xxs medium-padding-left-xxs align-center grid-x medium-margin-top-xs margin-top-xs small-margin-top-xs"
                  >
                    <div class="grid-x align-center-middle">
                      <div class="medium-margin-right-xxs" style="width: 15px; height: 15px">
                        <AtomicUiSkeleton height="14px" width="14px" />
                      </div>
                      <div class="show-for-large">
                        <AtomicUiSkeleton height="20px" width="38px" />
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="!isRegistrant"
                    class="small-padding-left-xxs medium-padding-left-xs align-center grid-x medium-margin-top-xs margin-top-xs small-margin-top-xs"
                  >
                    <div class="grid-x align-center-middle">
                      <div class="medium-margin-right-xxs" style="width: 16px; height: 13px">
                        <AtomicUiSkeleton height="14px" width="14px" />
                      </div>
                      <div class="print-text">
                        <AtomicUiSkeleton height="20px" width="30px" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="cell small-12 medium-12 large-4 xlarge-4 digit-text">
          <div class="meta-info grid-x medium-margin-top-xxs" :class="{ 'align-right': !checkMew, 'align-center': checkMew }">
            <div v-if="isRegistrant" class="text-center xlarge-padding-right-m large-padding-right-xxs medium-padding-right-m small-padding-right-l">
              <div class="h2 padding-bottom-xxs margin-left-xxs">
                <AtomicUiSkeleton :height="checkMew ? '26px' : '42px'" width="58px" />
              </div>
              <div class="macys-sans-regular-h3 margin-top-xxs">
                <AtomicUiSkeleton height="20px" width="74px" />
              </div>
            </div>

            <div v-if="isRegistrant" class="text-center xlarge-padding-right-m large-padding-right-xxs medium-padding-right-m small-padding-right-l">
              <div class="h2 padding-bottom-xxs margin-left-xxs">
                <AtomicUiSkeleton :height="checkMew ? '26px' : '42px'" width="58px" />
              </div>
              <div class="macys-sans-regular-h3 margin-top-xxs">
                <AtomicUiSkeleton height="20px" width="74px" />
              </div>
            </div>
            <div class="text-center">
              <div class="h2 padding-bottom-xxs margin-left-xxs">
                <AtomicUiSkeleton :height="checkMew ? '26px' : '42px'" width="58px" />
              </div>
              <div class="macys-sans-regular-h3 margin-top-xxs">
                <AtomicUiSkeleton height="20px" width="74px" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useEnvPropsStore } from '~/stores/envProps';

defineProps({
  isRegistrant: {
    type: Boolean,
    default: false,
    required: true,
  },
});

const envPropsStore = useEnvPropsStore();
const checkMew = computed(() => envPropsStore.envProps.isMew);
</script>
<style lang="scss" scoped>
.registry-event-details {
  div {
    position: relative;
    &:before {
      content: '';
      height: rem-calc(13);
      width: rem-calc(1);
      position: absolute;
      left: 0;
      top: rem-calc(4);
      background-color: $gray-4-color;
    }
    &:nth-child(1)::before {
      background: transparent;
    }
  }
}
.event-type-image {
  overflow: hidden;
}

.skeleton,
.text-center {
  @include breakpoint(medium down) {
    margin: auto;
  }
}
</style>
